import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import api from "@/lib/api";
import { ACCESS, hasAnyPermission } from "@/lib/permissions";
import { PLAN_FEATURES, hasPlanFeature } from "@/lib/planFeatures";

const tabs = [
  { label: "Create Proposal", path: "/proposals/create" },
  { label: "Sent Proposals", path: "/proposals/sent" },
  { label: "Partner Network", path: "/partner-network", permissions: ACCESS.partnerNetwork, settingsFlag: "partnerNetworkEnabled" },
  { label: "Arrangements", path: "/proposals/arrangements", planFeature: PLAN_FEATURES.proposalCustom },
];

export function ProposalTabs() {
  const location = useLocation();
  const { user } = useAuth();
  const [partnerNetworkEnabled, setPartnerNetworkEnabled] = useState(false);

  useEffect(() => {
    if (!user || !hasAnyPermission(user, ACCESS.partnerNetwork)) {
      setPartnerNetworkEnabled(false);
      return;
    }
    let cancelled = false;
    api.get("/partner-network/settings", { skipGlobalLoader: true })
      .then(({ data }) => {
        if (!cancelled) setPartnerNetworkEnabled(!!data?.enabled);
      })
      .catch(() => {
        if (!cancelled) setPartnerNetworkEnabled(false);
      });
    return () => {
      cancelled = true;
    };
  }, [user]);

  useEffect(() => {
    const handlePartnerNetworkSettingChange = (event) => {
      setPartnerNetworkEnabled(!!event.detail?.showInSidebar);
    };
    window.addEventListener("partner-network-sidebar-setting-changed", handlePartnerNetworkSettingChange);
    return () => {
      window.removeEventListener("partner-network-sidebar-setting-changed", handlePartnerNetworkSettingChange);
    };
  }, []);

  const visibleTabs = tabs.filter((tab) => {
    if (tab.permissions?.length && !hasAnyPermission(user, tab.permissions)) return false;
    if (tab.planFeature && !hasPlanFeature(user, tab.planFeature)) return false;
    if (tab.settingsFlag === "partnerNetworkEnabled" && !partnerNetworkEnabled) return false;
    return true;
  });

  return (
    <div className="hx-segmented-tabs hx-proposal-tabs mb-5">
      {visibleTabs.map((tab) => {
        const active = location.pathname === tab.path;
        return (
          <Link
            key={tab.path}
            to={tab.path}
            className={`hx-segmented-tab${active ? " is-active" : ""}`}
          >
            {tab.label}
          </Link>
        );
      })}
    </div>
  );
}
